module.exports = __webpack_public_path__ + "img/address.b29c3d0c.png";